import React from 'react';

import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useNavigate} from 'react-router-dom';

import {useTenantInfo} from 'modules/tenant/hooks';
import {formatAxiosErrorOrThrow} from 'shared/utils/error';
import {ICreateUserForm} from 'users/pages/CreateUser/CreateUser';
import {createUserFromPublicSignupPage} from 'modules/user/api/user';
import { useSignupPageIdFromUrl } from 'modules/signup-page/hooks/useSignupPageIdFromUrl';

import {FullScreenModal} from 'shared/components/FullScreenModal/FullScreenModal';
import {FullScreenModalTitle} from 'shared/components/FullScreenModal/FullScreenModalTitle';
import {PublicSignupStudentForm } from 'shared/pages/Signup/PublicSignup/PublicSignupStudent/PublicSignupStudentForm';
import { PublicSignupStudentConfirm } from 'shared/pages/Signup/PublicSignup/PublicSignupStudent/PublicSignupStudentConfirm';

// import './styles.scss';

export const PublicSignupStudent = () => {
    const {t} = useTranslation();
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

    const [step, setStep] = React.useState<boolean>(false);

    const {tenantInfo} = useTenantInfo();
    const signupPageId = useSignupPageIdFromUrl();

    const navigate = useNavigate();

    const onSubmit = ({role, ...userCreate}: ICreateUserForm) => {
        if (isSubmitting || !signupPageId) {
            return;
        }
        setIsSubmitting(true);
        (async () => {
            try {
                await createUserFromPublicSignupPage(
                    tenantInfo.id,
                    signupPageId,
                    {
                        roles: [role],
                        ...userCreate,
                    },
                );
                // redirect to login page
                navigate('/login');
                setStep(true);
                toast.success(t('signup.success', 'Signup successful! Please login'));
            } catch (e) {
                toast.error(formatAxiosErrorOrThrow(t(
                    'signup.submit.error', 'There was an error',
                ), e));
            } finally {
                setIsSubmitting(false);
            }
        })();
    };

    return (
        <FullScreenModal close={false} size="md">
            <FullScreenModalTitle className="mb-4">
                {t(
                    'common.parentSignup.title', 'Sign up as a Student to Young Eyes {{tenantName}}',
                    {tenantName: tenantInfo.name},
                )}
            </FullScreenModalTitle>
            {step === false ? (
                <PublicSignupStudentForm isSubmitting={isSubmitting} onSubmit={onSubmit}/>
            ) : (
                <PublicSignupStudentConfirm/>
            )}
        </FullScreenModal>
    );
};